import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

export default function getCopilotPlatforms(): OperatorApplicationApi.OperatorGetParamsPlatformOpenApiModel[] {
    return OperatorAccountStore.data.value.platforms.filter(platform => platform.isCopilot);
}